import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { Spinner } from "reactstrap";
import {
  setAccessToken,
  setRefreshToken,
  setIdToken,
  getAccessToken,
} from "config";
import LoginComponent from "views/auth/Login";
import useAuth from "hooks/useAuth";
import { ACCOUNT_COMMITTEE, congRoles } from "utility/constants";

const PrivateRoute = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const { user } = useAuth();
  const role = user?.type || null;
  const cong = user?.congressman || null;

  const getLocalSession = async () => {
    try {
      const session = await Auth.currentSession();

      if (session) {
        setAccessToken(session?.accessToken?.jwtToken);
        setRefreshToken(session?.refreshToken?.token);
        setIdToken(session?.idToken?.jwtToken);
        setIsLoggedIn(true);
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);

      const storedToken = getAccessToken();

      if (storedToken) {
        // User is authenticated via codeLogin (token exists)
        // For codeLogin users, we allow access even without user details
        // as they have specific permissions set
        setIsLoggedIn(true);
      } else if (
        e === "No current user" ||
        Object.values(e)[0] === "NotAuthorizedException"
      ) {
        localStorage.clear();
        setIsLoggedIn(false);
        navigate("/login");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getLocalSession();
  }, []);

  useEffect(() => {
    if (isLoading) return;

    if (
      role === "Others" &&
      (window.location.pathname === "/home" || window.location.pathname === "/")
    ) {
      navigate("/dpwhlisting");
    }

    if (
      congRoles.includes(role) &&
      (window.location.pathname === "/home" || window.location.pathname === "/")
    ) {
      navigate(`/representatives/${cong?.region?.id}/cong/${cong?.id}`);
    }

    if (
      role === ACCOUNT_COMMITTEE &&
      (window.location.pathname === "/home" || window.location.pathname === "/")
    ) {
      navigate("/committee");
    }
  }, [isLoading, role, cong]);

  if (isLoading) {
    return <Spinner />;
  }

  if (isLoggedIn) {
    return <Outlet />;
  }

  return <LoginComponent />;
};

export default PrivateRoute;
